var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"v-placeholder"},[_c('v-text',{staticClass:"text-center",attrs:{"font-size":"5"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }